import { z } from 'zod';
/**
 * État affiché d'une opération dans la liste — `02` §10. Calculé, non stocké.
 *
 * Depuis la refonte du 10/09/2026, une opération désactivée est explicitement
 * « Inactive » : le client doit voir d'un coup d'œil qu'une campagne écrite
 * n'est pas en train de tourner, sans lire sa période.
 */
export const OPERATION_LIFECYCLES = ['inactive', 'upcoming', 'running', 'finished', 'archived'];
export const operationLifecycleSchema = z.enum(OPERATION_LIFECYCLES);
export const OPERATION_LIFECYCLE = {
    inactive: {
        code: 'inactive',
        label: 'Inactive',
        tone: 'gray',
        description: 'Désactivée : elle ne s’applique à aucune commande.',
    },
    upcoming: { code: 'upcoming', label: 'À venir', tone: 'blue' },
    running: { code: 'running', label: 'En cours', tone: 'green' },
    finished: { code: 'finished', label: 'Terminée', tone: 'gray' },
    archived: { code: 'archived', label: 'Archivée', tone: 'gray' },
};
//# sourceMappingURL=operation.js.map